import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "vh-100 d-flex justify-content-center align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "user-form email-setts"
}
const _hoisted_3 = { class: "user-form profile-form" }
const _hoisted_4 = { class: "row h2" }
const _hoisted_5 = { class: "col-md-6 col-sm-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-basket-fill" }, null, -1)
const _hoisted_7 = { class: "d-flex justify-content-end align-items-center col-md-6 col-sm-12" }
const _hoisted_8 = { class: "me-2" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "small-fs-1" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-left-fill" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clearboth" }, null, -1)
const _hoisted_15 = { class: "setting-data" }
const _hoisted_16 = { class: "row align-items-center" }
const _hoisted_17 = { class: "col-md-6 col-sm-12 mb-0" }
const _hoisted_18 = { class: "col-md-6 col-sm-12 d-flex justify-content-end" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "table" }
const _hoisted_21 = {
  "show-sm": "",
  "show-xs": "",
  "hide-md": "",
  "hide-lg": "",
  class: "d-block d-md-none"
}
const _hoisted_22 = { class: "d-block my-3" }
const _hoisted_23 = { class: "d-none d-md-block" }
const _hoisted_24 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_25 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_26 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_27 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_28 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "d-none t-d-md-table-cell" }, null, -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { colspan: "6" }
const _hoisted_32 = { class: "text-center py-2" }
const _hoisted_33 = { class: "d-none d-md-block" }
const _hoisted_34 = ["onClick", "title"]
const _hoisted_35 = {
  class: "d-block d-md-none",
  style: {"position":"relative"}
}
const _hoisted_36 = { style: {"padding":"5px 0"} }
const _hoisted_37 = { class: "bold" }
const _hoisted_38 = ["onClick", "title"]
const _hoisted_39 = { style: {"padding":"5px 0"} }
const _hoisted_40 = { class: "bold" }
const _hoisted_41 = { style: {"padding":"5px 0"} }
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = { style: {"padding":"5px 0"} }
const _hoisted_44 = { class: "bold" }
const _hoisted_45 = { style: {"padding":"5px 0"} }
const _hoisted_46 = { class: "bold" }
const _hoisted_47 = { style: {"padding":"5px 0"} }
const _hoisted_48 = { class: "bold" }
const _hoisted_49 = { class: "discl-menu dropdown pos-abs-top-right not-large" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "discl-menu-caret dropdown-toggle",
  id: "dropBrok1",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_51 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropBrok1"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_55 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_56 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_57 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_58 = { class: "d-none t-d-md-table-cell text-end" }
const _hoisted_59 = { class: "d-none t-d-md-table-cell" }
const _hoisted_60 = { class: "sett-small-menu align-right" }
const _hoisted_61 = { class: "discl-menu dropdown" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("a", {
  class: "discl-menu-caret dropdown-toggle",
  href: "javascript:void(0)",
  role: "button",
  id: "dropdownMenuLink",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, null, -1)
const _hoisted_63 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "dropdownMenuLink"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "col-md-6 col-sm-12" }
const _hoisted_67 = { class: "area-info" }
const _hoisted_68 = { class: "col-md-6 col-sm-12" }
const _hoisted_69 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_jw_pager = _resolveComponent("jw-pager")!
  const _component_printer_dialog = _resolveComponent("printer-dialog")!
  const _component_SalesOrderDetailModal = _resolveComponent("SalesOrderDetailModal")!
  const _component_SalesOrderPaytModal = _resolveComponent("SalesOrderPaytModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isStillLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_font_awesome_icon, {
            icon: ['fa', 'fa-spinner'],
            class: "fs-1"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("  " + _toDisplayString(_ctx.language.order_dets), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control input-sm",
                    placeholder: _ctx.language.search.toLowerCase(),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemSearchKey) = $event))
                  }, null, 8, _hoisted_9), [
                    [_vModelText, _ctx.itemSearchKey]
                  ])
                ])
              ])
            ]),
            _createElementVNode("p", _hoisted_10, [
              (!_ctx.relatedPurchase.bReady)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['fa', 'fa-spinner']
                  }))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _createVNode(_component_RouterLink, { to: "/app/sales/sales/list" }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _createTextVNode("  " + _toDisplayString(_ctx.language.sales_order) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.relatedPurchase.record.OrderNbr), 1),
                        _createTextVNode("  " + _toDisplayString(_ctx.language.customer) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getCustomerName), 1),
                        _hoisted_13,
                        _createTextVNode("       " + _toDisplayString(_ctx.language.total_amt) + ": ", 1),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(_ctx.getTotalAmt)), 1),
                        _createTextVNode("  ")
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.language.order_dets_msg), 1),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.language.order_dets), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addSalesOrderDetails(0, null)))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.new), 1)
                  ]),
                  _createTextVNode("  "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn-xs",
                    disabled: _ctx.listOfSalesOrderDetails.length == 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveRecordData()))
                  }, [
                    (_ctx.isSavingRecord)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: ['fas', 'spinner']
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isSavingRecord)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 1,
                          icon: ['fas', 'save']
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode("  " + _toDisplayString(_ctx.language.save), 1)
                  ], 8, _hoisted_19)
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_20, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, [
                    _createElementVNode("span", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.language.order_dets), 1)
                    ]),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.language.product), 1)
                  ]),
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.language.qty), 1),
                  _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.language.unit_price), 1),
                  _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.language.discount), 1),
                  _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.language.tax), 1),
                  _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.language.total), 1),
                  _hoisted_29
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.listOfSalesOrderDetails.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                      _createElementVNode("td", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.language.no_rec_fnd), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsPageElts, (salesDet) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "acct-cal-verified",
                    key: salesDet.OrderDetailKey
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_33, [
                        _createElementVNode("a", {
                          href: "javascript:;",
                          onClick: ($event: any) => (_ctx.addSalesOrderDetails(1, salesDet)),
                          title: _ctx.language.preview
                        }, _toDisplayString(_ctx.getProductName(salesDet)), 9, _hoisted_34),
                        _createTextVNode("  ")
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.language.product) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, [
                            _createElementVNode("a", {
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addSalesOrderDetails(1, salesDet)),
                              title: _ctx.language.preview
                            }, _toDisplayString(_ctx.getProductName(salesDet)), 9, _hoisted_38),
                            _createTextVNode("  ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.language.qty) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.Quantity)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.language.unit_price) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.UnitPrice)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.language.discount) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.DiscountAmount)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.language.tax) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.TaxValue)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.language.tax) + ":", 1),
                          _createTextVNode("  "),
                          _createElementVNode("span", null, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.TotalAmt)), 1)
                        ]),
                        _createElementVNode("span", _hoisted_49, [
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.addSalesOrderDetails(1, salesDet))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'edit'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                            ], 8, _hoisted_52),
                            _createElementVNode("a", {
                              class: "dropdown-item py-2",
                              href: "javascript:;",
                              onClick: ($event: any) => (_ctx.deleteSalesDetail(salesDet))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] }),
                              _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                            ], 8, _hoisted_53)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.Quantity)), 1),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.UnitPrice)), 1),
                    _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.DiscountAmount)), 1),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.TaxValue)), 1),
                    _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.currCode) + " " + _toDisplayString(_ctx.appFxs.formatNumbers(salesDet.TotalAmt)), 1),
                    _createElementVNode("td", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("span", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("ul", _hoisted_63, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.addSalesOrderDetails(1, salesDet))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-edit'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.edit), 1)
                              ], 8, _hoisted_64)
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item py-2",
                                href: "javascript:;",
                                onClick: ($event: any) => (_ctx.deleteSalesDetail(salesDet))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-trash'] }),
                                _createTextVNode(" " + _toDisplayString(_ctx.language.delete), 1)
                              ], 8, _hoisted_65)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["row margin-to-15", {'d-none': _ctx.listOfSalesOrderDetails.length==0}])
            }, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createTextVNode(_toDisplayString(_ctx.language.total_entries) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.listOfSalesOrderDetails.length), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("nav", _hoisted_69, [
                  _createVNode(_component_jw_pager, {
                    items: _ctx.filteredRecordItems,
                    initialPage: 1,
                    pageSize: _ctx.itemsPerPage,
                    maxPages: 10,
                    onChangePage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPageChange($event)))
                  }, null, 8, ["items", "pageSize"])
                ])
              ])
            ], 2)
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals-container" }, [
      _createVNode(_component_printer_dialog, {
        visible: _ctx.isPrintvisible,
        onCloseForm: _ctx.onPrintClose,
        printBaseData: _ctx.printInitialValues,
        extraPrintData: _ctx.printExtraData
      }, null, 8, ["visible", "onCloseForm", "printBaseData", "extraPrintData"]),
      _createVNode(_component_SalesOrderDetailModal, {
        visible: _ctx.isSalesDetailVis,
        initialValues: _ctx.salesDetInitVals,
        recordStatus: _ctx.salesDetRecStatus,
        listOfProducts: _ctx.listOfProducts,
        listOfVariants: _ctx.lstOfProdVariantValues,
        listOfDiscounts: _ctx.listOfDiscountWithRules,
        listOfTaxes: _ctx.listOfTaxSettings,
        orderRecord: _ctx.currentSalesOper,
        onCloseForm: _ctx.onDetailClose
      }, null, 8, ["visible", "initialValues", "recordStatus", "listOfProducts", "listOfVariants", "listOfDiscounts", "listOfTaxes", "orderRecord", "onCloseForm"]),
      _createVNode(_component_SalesOrderPaytModal, {
        visible: _ctx.isSalesPaytVis,
        initialValues: _ctx.salesPaytInitVals,
        recordStatus: _ctx.salesPaytRecStatus,
        remainingAmt: _ctx.salesRemAmt,
        onCloseForm: _ctx.onClosePaytModal,
        populateData: false
      }, null, 8, ["visible", "initialValues", "recordStatus", "remainingAmt", "onCloseForm"])
    ]))
  ], 64))
}